import Decimal from "decimal.js";

export const formatDate = (date: Date | string | null) => {
  if (!date) {
    return "-";
  }
  return new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const formatCurrency = (amount: number | string | null) => {
  if (amount === null || amount === undefined) {
    return "-";
  }
  const amountNumber =
    typeof amount === "string" ? stringToNumber(amount) : amount;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amountNumber);
};

export const stringToNumber = (amount: string) => {
  return new Decimal(amount).toNumber();
};
